import styled from 'styled-components';

export const Label = styled.label<{ ignoreClicks?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;

  ${({ ignoreClicks }) =>
    ignoreClicks
      ? `
    pointer-events: none;

    button {
      pointer-events: auto;
      }
    `
      : `
    cursor: pointer;    
  `}
`;
